import React, { useState } from 'react'
import _ from 'lodash'
import { compose } from 'recompose'
import { Form, Select, message } from 'antd'
import { inject } from 'mobx-react'
import { Query, graphql } from 'react-apollo'
import gql from 'graphql-tag'

const GET_SETTINGS = gql`
    query barangaySettingsByCode(
		$barangay_uid: String,
		$code: String
	) {
		barangaySettingsByCode(
			barangay_uid: $barangay_uid,
			code: $code
		)
    }
`

const SET_CITY_MUNICIPALITY = gql`
    mutation setCityMunicipality(
        $input: JSON
    ) {
        setCityMunicipality(
            input: $input
        )
    }
`

const Index = (props) => {
	const { 
		AuthStore, form, saveCityMunicipality, ...rest 
	} = props
	const { getFieldDecorator, resetFields } = form
	const { barangay_uid } = AuthStore
	const [isSaving, setSaving] = useState(false)
    
	const handleSubmit = (e) => {
		e.preventDefault()
		form.validateFields((err, values) => {
			if (err) {
				return false
			}
            
			values = Object.assign({}, values, { barangay_uid, code: 'CITY_MUNICIPALITY' })

			message.loading({ key: 'set_city_municipality', content: 'Saving, please wait..' })
			setSaving(true)
			saveCityMunicipality(values).then((response) => {
				setSaving(false)
				message.success({ key: 'set_city_municipality', content: 'City/Municipality successfully saved.' })
			}).catch(err => {
				setSaving(false)
				console.log('error saving city/municipality')
				message.error({ key: 'set_city_municipality', content: err.message.replace('GraphQL error:', '') })
				resetFields()
			})
		})
	}

	return (
		<Query query={GET_SETTINGS} variables={{ barangay_uid, code: 'CITY_MUNICIPALITY' }}>
			{({ loading, error, data }) => {

				const mSetting = _.has(data, 'barangaySettingsByCode') ? data.barangaySettingsByCode : {}
				return (
					<div style={{ position: 'relative' }}>
						<Form onSubmit={handleSubmit}>
							<Form.Item label='City / Municipality'>
								{ getFieldDecorator('city_municipality', {
									initialValue: (mSetting) ? mSetting.value : null,
									rules: [{
										required: true,
										message: 'This field is required.'
									}, {
										validator: (rule, value, callback) => {
											if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
												callback('only white space detected.')
											}
											callback()
										}
									}]
								})
								(
									<Select 
										placeholder='Select Type'
									>
										<Select.Option value='City'>City</Select.Option>
										<Select.Option value='Municipality'>Municipality</Select.Option>
									</Select>
								)}
							</Form.Item>
						</Form>
						<button disabled={isSaving} onClick={handleSubmit} style={{ position: 'absolute', top: '49px', right: '1px' }} type="button" className="btn btn-primary waves-effect waves-light">Save</button>
					</div>
				)
			}}
		</Query>
	)
}

const composed = compose(
	Form.create({ name: 'form-city-municipality' }),
	inject('AuthStore'),
	graphql(SET_CITY_MUNICIPALITY, {
		props({ mutate }) {
			return {
				saveCityMunicipality(params) {
					return mutate({
						variables: { input: params },
					  	refetchQueries: ['barangaySettingsByCode']
					})
				}
			}
		}
	}),
)

export default composed(Index)